import { Component, Input, TemplateRef } from '@angular/core';
import { IconType } from '@shared/utils/icons';
import { NavbarMenuItem } from '@shared/utils/menu-items';

@Component({
  selector: 'shared-ui-navbars-horizontal-navbar',
  templateUrl: './horizontal-navbar.component.html',
  styleUrls: ['./horizontal-navbar.component.css'],
  standalone: false,
})
export class HorizontalNavbarComponent {
  @Input() items: NavbarMenuItem[] | undefined = new Array<NavbarMenuItem>();
  @Input() startTemplate: TemplateRef<unknown> | null = null;
  @Input() endTemplate: TemplateRef<unknown> | null = null;

  iconType = IconType;
  constructor() {}
}
